var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "dl",
    {
      staticClass:
        "icons-landing-stats margin-0 padding-0 display-flex flex-wrap flex-items-center flex-content-center",
    },
    [
      _c("dt", { staticClass: "sr-only" }, [
        _vm._v("About Font Awesome Icons"),
      ]),
      _vm._v(" "),
      _c(
        "dd",
        { staticClass: "icons-landing-stat size-sm margin-bottom-0" },
        [
          _c("font-awesome-icon", {
            staticClass: "margin-right-3xs",
            attrs: {
              icon: _vm.$v6.solid.faShapes,
              "fixed-width": "",
              size: "lg",
            },
          }),
          _vm._v(" "),
          _c(
            "site-link",
            {
              attrs: { to: _vm.$search() },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture(
                    "icons_landing:stats_link_click",
                    { stat: "total_icons", location: "icons_stats" }
                  )
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$counts.icons.all.formatted) +
                  " Icons\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "dd",
        { staticClass: "icons-landing-stat size-sm margin-bottom-0" },
        [
          _c("font-awesome-icon", {
            staticClass: "margin-right-3xs",
            attrs: {
              icon: _vm.$v6.solid.faGift,
              "fixed-width": "",
              size: "lg",
            },
          }),
          _vm._v(" "),
          _c(
            "site-link",
            {
              attrs: { to: { hash: "#packs" } },
              nativeOn: {
                click: function ($event) {
                  return (() => {
                    _vm.$posthog.capture("icons_landing:stats_link_click", {
                      stat: "total_packs",
                      location: "icons_stats",
                    })
                    _vm.setSelectedTab("packs")
                  }).apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n      " + _vm._s(_vm.iconPacksCount) + " Icon Packs\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "dd",
        { staticClass: "icons-landing-stat size-sm margin-bottom-0" },
        [
          _c("font-awesome-icon", {
            staticClass: "margin-right-3xs",
            attrs: {
              icon: _vm.$v6.solid.faPalette,
              "fixed-width": "",
              size: "lg",
            },
          }),
          _vm._v(" "),
          _c(
            "site-link",
            {
              attrs: { to: _vm.$search() },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture(
                    "icons_landing:stats_link_click",
                    { stat: "total_styles", location: "icons_stats" }
                  )
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.$counts.totalLatestStylesWithoutBrands) +
                  " Icon Styles\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "dd",
        { staticClass: "icons-landing-stat size-sm margin-bottom-0" },
        [
          _c("font-awesome-icon", {
            staticClass: "margin-right-3xs",
            attrs: {
              icon: _vm.$v6.solid.faFolder,
              "fixed-width": "",
              size: "lg",
            },
          }),
          _vm._v(" "),
          _c(
            "site-link",
            {
              attrs: { to: { hash: "#categories" } },
              nativeOn: {
                click: function ($event) {
                  return (() => {
                    _vm.$posthog.capture("icons_landing:stats_link_click", {
                      stat: "total_categories",
                      location: "icons_stats",
                    })
                    _vm.setSelectedTab("categories")
                  }).apply(null, arguments)
                },
              },
            },
            [
              _vm._v(
                "\n      " +
                  _vm._s(_vm.iconCategoriesCount) +
                  " Categories\n    "
              ),
            ]
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "dd",
        { staticClass: "icons-landing-stat size-sm margin-bottom-0" },
        [
          _c("font-awesome-icon", {
            staticClass: "margin-right-3xs",
            attrs: {
              icon: _vm.$v6.solid.faSparkles,
              "fixed-width": "",
              size: "lg",
            },
          }),
          _vm._v(" "),
          _c(
            "site-link",
            {
              attrs: { to: _vm.$docs("/web/add-icons/icon-wizard") },
              nativeOn: {
                click: function ($event) {
                  return _vm.$posthog.capture(
                    "icons_landing:stats_link_click",
                    {
                      stat: "total_icon_wizard_possibilities",
                      location: "icons_stats",
                    }
                  )
                },
              },
            },
            [_vm._v("\n      1.8 Million Icon Possibilities")]
          ),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }